// extracted by mini-css-extract-plugin
export default {"container":"System_container__vmxeq","grid":"System_grid__6XVRL"};